import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import InputSelectField from './InputSelectField';
import InputTextField from './InputTextField';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import './ParkerAccessDeviceTableRow.scss';
import moment from 'moment-timezone';

export default function ParkerAccessDeviceTableRow(props) {
  const {
      onAccessDeviceChange,
      accessDevice: {
        fields: {
          type,
          device_identifier,
          device_status,
          device_date_added,
          device_date_active,
          device_date_inactive,
          device_inactive_reason,
        },
        newDevice,
      },
      allowRemove,
      editMode,
      fieldConfiguration: {
        type: typeConfig,
        device_inactive_reason: reasonsConfig,
        facilityTimezone,
      },
      ident,
    } = props;

  const [ unSavedChanges, setUnSavedChanges ] = useState(false);
  const [ initialDeviceID, setInitialDeviceID ] = useState(device_identifier.value);
  const [ initialDeviceStatus, setInitialDeviceStatus ] = useState(device_status.value);


  const dateFormat = 'MM/DD/YYYY';
  const now = moment.tz(facilityTimezone)
  // const yesterday = moment(now).subtract(1, 'day').format('MM/DD/YYYY');

  useEffect(() => {
    if (!editMode) {
      setUnSavedChanges(false);
      setInitialDeviceID(device_identifier.value);
      setInitialDeviceStatus(device_status.value);
    }
  }, [editMode, device_identifier, device_status.value]);

  const _onInputValueChange = inputId => {
    return (value, dateValue = null) => {
      setUnSavedChanges(true);
      const updateAccessDevice = _.cloneDeep(props.accessDevice);
      updateAccessDevice.fields[inputId].value = dateValue || value;

      if (inputId === 'type') {
        updateAccessDevice.fields.device_status.value = 'ACTIVE';
        updateAccessDevice.fields.device_date_active.value = now.format(dateFormat);
      }


      if (dateValue) {
        /* THESE ARE THE CONDITIONS THAT THE FOLLOWING LOGIC ADDRESSES
          • Device status is no longer a dropdown, just dynamic text based on active and inactive dates
          • Active Date field should always be editable, unless the device is in an inactive status
          • Do not allow inactive dates to be before an active date
          • Do not allow an active date to be after an inactive date
          • Active dates in the future should default the device status to inactive
          • Devices with future active date with an inactive status should remain editable
        */

        // const isBeforeYesterday = value.isBefore(yesterday, 'day');
        // const isYesterday = value.isSame(yesterday, 'day');


        const isBeforeDateAdded = value.isBefore(device_date_added.value, 'day');
        const isBeforeDateActive = value.isBefore(device_date_active.value, 'day');
        const deviceActiveIsAfterCurrentDate = moment(device_date_active.value, dateFormat, facilityTimezone).isAfter(now, 'day');
        const hasDateInactive = !!device_date_inactive.value;
        const isAfterDateInactive = value.isAfter(device_date_inactive.value, 'day');
        const isSameOrBeforeCurrentDate =  value.isSameOrBefore(now, 'day');

        if (inputId === 'device_date_active') {
          if (isBeforeDateAdded || (hasDateInactive && isAfterDateInactive)) return;
          updateAccessDevice.fields.device_status.value = isSameOrBeforeCurrentDate ? 'ACTIVE' : 'INACTIVE';
        }

        if (inputId === 'device_date_inactive') {
          if (isBeforeDateAdded || isBeforeDateActive) return;
          // if (isBeforeYesterday) return;

          if (deviceActiveIsAfterCurrentDate) {
            updateAccessDevice.fields.device_status.value = 'INACTIVE';
           } else {
            updateAccessDevice.fields.device_status.value = 'ACTIVE';
            updateAccessDevice.fields.device_inactive_reason.value = null;
          }
        }
      }


      /* THIS SCENARIO ADDRESSES WHEN A USER REMOVES A DATE COMPLETELY FROM A DATE FIELD */
      if (!updateAccessDevice.fields.device_date_active.value) {
        updateAccessDevice.fields.device_status.value = 'INACTIVE';
      }

      /* THIS SCENARIO ADDRESSES WHEN A USER REMOVES A DATE COMPLETELY FROM A DATE FIELD */
      if (!updateAccessDevice.fields.device_date_inactive.value) {
        updateAccessDevice.fields.device_inactive_reason.value = null;
      }

      if (inputId === 'device_inactive_reason' && !value) return

      props.onAccessDeviceChange(updateAccessDevice);
    };
  }

  const _activeDateAsMoment = moment.tz(device_date_active.value, dateFormat, facilityTimezone);
  const _inactiveDateAsMoment = moment.tz(device_date_inactive.value, dateFormat, facilityTimezone);

  const _activeDateTodayOrBefore = _activeDateAsMoment.isSameOrBefore(now, 'day');
  const _activeDateSameOrAfterToday = _activeDateAsMoment.isSameOrAfter(now, 'day');
  const _inactiveDateBeforeToday = _inactiveDateAsMoment.isBefore(now, 'day');

  const _canEditField = editMode && (
    (device_status.value !== 'INACTIVE' || unSavedChanges) || _activeDateSameOrAfterToday
  );
  const _activeDateRestricted =  type.value === 'BARCODE' || (_activeDateTodayOrBefore && !unSavedChanges);
  const _inactiveDateRestricted =  type.value === 'BARCODE' || (_inactiveDateBeforeToday && unSavedChanges);
  const _deviceIdentifierRestricted = type.value === 'BARCODE' || !!initialDeviceID;

  return (
    <TableRow key={ident}>
      <TableCell>

        {allowRemove && newDevice && (
          <button
            className="parkchirp--button-as-link btn-RemoveTableRow"
            label="Remove Row"
            onClick={() => { onAccessDeviceChange(null) }}
            type="button"
          >
            <HighlightOffIcon color="error" />
          </button>
        )}

        {_canEditField && newDevice ?
          <InputSelectField
            inputId={`parkchirp--parker--access-device--${ident}--type`}
            options={[
              { value: null, label: 'Choose a Type' },
              ...typeConfig.options,
            ]}
            value={type.value}
            onChange={_onInputValueChange('type')}
            editMode={true}
          />
        :
          <span>{type.value}</span>
        }

      </TableCell>
      <TableCell>
        {_canEditField && !_deviceIdentifierRestricted ?
          <InputTextField
            inputId={`parkchirp--parker--access-device--${ident}--id`}
            value={device_identifier.value}
            onChange={_onInputValueChange('device_identifier')}
            editMode={true}
          />
        :
          <span>{device_identifier.value}</span>
        }
      </TableCell>
      <TableCell>
        <span>{initialDeviceStatus}</span>
      </TableCell>
      <TableCell>
          <InputTextField
            inputId={`parkchirp--parker--access-device--${ident}--date-added`}
            value={device_date_added.value}
            editMode={false}
          />
      </TableCell>
      <TableCell>
        {_canEditField && !_activeDateRestricted ?
          <MuiPickersUtilsProvider utils={MomentUtils} className='parkchirp--input-text-field' >
            <KeyboardDatePicker
              id={`parkchirp--parker--access-device--${ident}--date-active`}
              disableToolbar
              variant="inline"
              value={device_date_active.value}
              onChange={_onInputValueChange('device_date_active')}
              format="MM/DD/YYYY"
              inputValue={device_date_active.value}
              autoOk={true}
              showTodayButton={true}
            />
          </MuiPickersUtilsProvider>
        :
          <span>{type.value !== 'BARCODE' && device_date_active.value}</span>
        }
      </TableCell>
      <TableCell>
        {_canEditField && !_inactiveDateRestricted ?
          <MuiPickersUtilsProvider utils={MomentUtils} className="parkchirp--input-text-field" >
            <KeyboardDatePicker
              id={`parkchirp--parker--access-device--${ident}--date-inactive`}
              disableToolbar
              variant="inline"
              value={device_date_inactive.value}
              onChange={_onInputValueChange('device_date_inactive')}
              format="MM/DD/YYYY"
              inputValue={device_date_inactive.value}
              autoOk={true}
              showTodayButton={true}
            />
          </MuiPickersUtilsProvider>
        :
          <span>{type.value !== 'BARCODE' && device_date_inactive.value}</span>
        }
      </TableCell>
      <TableCell>
        {_canEditField && !_inactiveDateRestricted && device_date_inactive.value ?
          <InputSelectField
            inputId={`parkchirp--parker--access-device--${ident}--inactive-reason`}
            options={[
              { value: null, label: '' },
              ...reasonsConfig.options,
            ]}
            value={device_inactive_reason.value}
            onChange={_onInputValueChange('device_inactive_reason')}
            editMode={true}
            error={device_status.value === 'INACTIVE' && !device_inactive_reason.value && device_date_inactive.value}
            helperText={device_status.value === 'INACTIVE' && !device_inactive_reason.value ? "Please select a Reason" : ""}
          />
        :
          <span>{type.value !== 'BARCODE' && device_inactive_reason.value}</span>
        }
      </TableCell>
    </TableRow>
  );
}
